import axios from 'axios'
import { API_ROOT, API_TOKEN_REFRESH } from 'api-config';

export function logOut() {
  sessionStorage.clear();
  window.location.reload();
}

export function refreshToken() {

  setTimeout(function() {
    if (sessionStorage.getItem('jwtRefreshToken')) {
      const tokenData = {
        refresh: sessionStorage.getItem('jwtRefreshToken')
      }
      axios.post(`${API_ROOT}/auth/jwt-refresh/`, tokenData)
        .then(res =>  sessionStorage.setItem('jwtToken', res.data.access))
        .catch(function(res) {
          logOut()
        });
    }
    refreshToken();
  },API_TOKEN_REFRESH)



}

export function setSessionOnLogin(res) {
  sessionStorage.setItem('jwtToken', res.token);
  sessionStorage.setItem('jwtRefreshToken', res.refreshToken);
  sessionStorage.setItem('userId', res.userId);
  sessionStorage.setItem('userUuid', res.userUuid);
  sessionStorage.setItem('userGroups', res.userGroups);
  sessionStorage.setItem('agreementAcknowledged', res.agreementAcknowledged);
  sessionStorage.setItem('primaryDentist', res.primaryDentist);
  sessionStorage.setItem('planId', res.planId);
  sessionStorage.setItem('bankAccountSet', res.bankAccountSet);
  sessionStorage.setItem('logoFile', res.logoFile);
}